import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, throwError } from 'rxjs';
import { AppSettings } from '../app-settings';

@Injectable({
  providedIn: 'root',
})
export class BusinessService {
  constructor(private http: HttpClient) {}

  getEventsCompanyFilter(
    idBusiness: number,
    page: number,
    searchText: any,
    sortFilter: any,
    spaces: any,
    draft: boolean | null = false,
    listSelect: boolean = false,
    toDate: any = null,
    all = true,
    active = false,
    fromDate: any = null,
    status: string = null,
    dateEndFrom: any = null,
    cancelled: boolean | null = null,
  ) {
    let url = `${AppSettings.API_URI_V2}/events?id_company=${idBusiness}`;
    if (searchText) {
      url += `&search=${searchText}`;
    }
    if (sortFilter) {
      url += `&sort=${sortFilter.sortedBy}:${sortFilter.sort}`;
    }
    if (spaces && spaces?.length > 0) {
      spaces.forEach((element) => {
        url += `&id_space=` + element;
      });
    }
    if (draft === true) {
      url += `&draft=true`;
    } else if (draft === false) {
      url += `&draft=false`;
    }
    if (fromDate) {
      url += `&date_from=${fromDate}`;
    }
    if (toDate) {
      url += `&date_to=${toDate}`;
    }
    if (dateEndFrom) {
      url += `&date_end_from=${dateEndFrom}`;
    }
    if (status) {
      url += `&status=${status}`;
    } else if (active) {
      url += `&publish=true`;
    }
    if (cancelled !== null) {
      url += `&cancelled=${cancelled}`;
    }
    if (listSelect) {
      url += `&per_page=400`;
    } else {
      url += `&page=${page}`;
    }
    return this.http.get<any>(url).pipe(
      map((data) => {
        return data;
      }),
      catchError((err) => {
        return throwError(() => err);
      }),
    );
  }

  getEventsReports(
    idBusiness: number,
    page: number,
    space: any,
    toDate: any = null,
    fromDate: any = null,
    year: number = null,
    month: number = null,
  ) {
    let url = `${AppSettings.API_URI_V2}/reports/events?id_company=${idBusiness}&page=${page}`;
    if (space && space?.length > 0) {
      url += `&id_space=${space}`;
      url += `&date_from=${fromDate}`;
    }
    if (fromDate) {
      url += `&date_from=${fromDate}`;
    }
    if (toDate) {
      url += `&date_to=${toDate}`;
    }
    if (year) {
      url += `&yearMonth[year]=${year}`;
    }
    if (month) {
      url += `&yearMonth[month]=${month}`;
    }

    return this.http.get<any>(url).pipe(
      map((data) => {
        return data;
      }),
      catchError((err) => {
        return throwError(() => err);
      }),
    );
  }

  createBussiness(data: any) {
    return this.http
      .post<any>(`${AppSettings.API_URI_V2}/admin/companies`, data)
      .pipe(
        map((data) => {
          return data;
        }),
        catchError((err) => {
          return throwError(() => err);
        }),
      );
  }

  getInfoCompany(slug: string) {
    const url = `${AppSettings.API_URI_V2}/companies/${slug}`;
    return this.http.get<any>(url).pipe(
      map((data) => {
        return data;
      }),
      catchError((err) => {
        return throwError(() => err);
      }),
    );
  }
}
